module.exports = __webpack_public_path__ + "img/cart.f3405aef.svg";